if ($('#product-detail').length > 0) {
    var vProductDetail = new Vue({
        el: '#product-detail',
        data: {
            isLoadingAddToViewingRequest: false,
            isLoadingAddToBag: false,
            huntlistProducts: [],
            isLoadingSellerAvailability: false,
            isRequestAskAvailability: false,
        },
        created: function () {
            this.getHuntlistProducts();
        },
        methods: {
            askSellerAvailability: function(isLogin) {
                if (!isLogin) {
                    alert ('Must login first to ask Availability.');
                    return false;
                }

                this.isLoadingSellerAvailability = true;
                var _self = this;

                this.$http.post(askProductAvailabilityUrl).then(function (success) {
                    if (success.ok) {
                        alert ('Your Availability Request is sent. We will inform you via whatsapp or email soon.');
                    }

                    _self.isLoadingSellerAvailability = false;
                    _self.isRequestAskAvailability = true;
                }, function (error) {
                    alert('You can\'t ask availability for your own item');
                    _self.isLoadingSellerAvailability = false;
                });
            },
            addToViewingRequest: function () {
                this.isLoadingAddToViewingRequest = true;

                var _self = this;

                this.$http.post(addToViewingRequestUrl, {product_code: productCode}).then(function (success) {
                    if (success.ok) {
                        var viewingRequest = success.data;

                        $('.viewingRequest.desktop #header-viewing-request-item-total').html(viewingRequest.total_items);
                        $('.viewingRequestWrapper.desktop #header-viewing-request-item-content').html(viewingRequest.items_view_content);
                        $('.loginWrapper.desktop').hide();
                        $('.myBagWrapper.desktop').hide();
                        $('.viewingRequestWrapper.desktop').fadeIn();
                    }

                    _self.isLoadingAddToViewingRequest = false;
                }, function (error) {
                    console.log(error);
                    _self.isLoadingAddToViewingRequest = false;
                });
            },
            addToBag: function (isShouldRedirect) {
                if (typeof isShouldRedirect == 'undefined') {
                    isShouldRedirect = false;
                }

                this.isLoadingAddToBag = true;

                var _self = this;
                var bagProductLocalStorageKey = 'bagProductCodes';
                var bagProductCodes = JSON.parse(localStorage.getItem(bagProductLocalStorageKey)) || [];

                this.$http.post(addToBagUrl, {product_code: productCode}).then(function (success) {
                    if (success.ok) {
                        var bag = success.data;

                        $('#product-detail .buttonBox').html('<a href="#" onclick="return false" class="button button-full button-secondary">On Hold</a>');
                        $('.myBag.desktop #header-bag-item-total').html(bag.item_total);
                        $('.myBagWrapper.desktop #header-bag-item-content').html(bag.item_view_content);
                        $('.loginWrapper.desktop').hide();
                        $('.viewingRequestWrapper.desktop').hide();
                        $('.myBagWrapper.desktop').fadeIn();

                        dataLayer.push({'event': 'added-to-cart'});

                        if ( ! bagProductCodes.includes(productCode)) {
                            bagProductCodes.push(productCode);
                        }

                        localStorage.setItem(bagProductLocalStorageKey, JSON.stringify(bagProductCodes));
                    }

                    _self.isLoadingAddToBag = false;

                    if (isShouldRedirect) {
                        window.location.href = redirectToBagUrl;
                    }
                }, function (error) {
                    alert(error.data.error.message);
                    _self.isLoadingAddToBag = false;
                });
            },
            getHuntlistProducts: function () {
                var _self = this;

                this.$http.get(huntlistUrl).then(function (success) {
                    if (success.ok) {
                        _self.huntlistProducts = success.data;
                    } else {
                        console.log("Error when get huntlist products.");
                    }
                }, function (error) {
                    var data = error.data;

                    if (error.status === 500) {
                        alert(data.error.message);
                    } else {
                        console.log(data);
                    }
                });
            },
            like: function (productCode, event) {
                if (typeof event != 'undefined') {
                    var button = $(event.target);
                    button.attr('disabled', 'disabled');
                    button.addClass('loading');
                }

                var _self = this;
                var isWatch = !this.huntlistProducts.includes(productCode.toString());

                this.doWatch(productCode, isWatch, function (success) {
                    if (typeof event != 'undefined') {
                        var button = $(event.target);
                        button.removeAttr('disabled');
                        button.removeClass('loading');
                    }

                    _self.getHuntlistProducts();
                });
            },
            doWatch: function (productCode, is, postWatch) {
                this.$http.post(restockUrl, {
                    code: productCode,
                    watch: is
                }).then(function (success) {
                    postWatch(success);
                }, function (error) {
                    alert(error.data.error.message);
                });
            }
        }
    });
}

$(document).ready(function () {
    $('#flexslider').bxSlider({
        mode: 'horizontal',
        pagerCustom: '#flexcarousel',
        controls: true,
        auto: false,
        touchEnabled: false,
        onSliderLoad: function () {
            $('#flexslider li').css('visibility', 'visible');
        }
    });

    // $('#flexcarousel').bxSlider({
    //     minSlides: 2,
    //     maxSlides: 6,
    //     slideWidth: 80,
    //     slideMargin: 10,
    //     pager: false,
    //     touchEnabled: false
    // });

    $('#tabs').tabs();

    if ($('#tabsSlider').length > 0 && $(window).width() < 960) {
        $('#tabsSlider').owlCarousel({
            items: 1,
            autoWidth: true,
            margin: 10,
            pagination: false
        });
    }

    // var owl2 = $('#itemsSlider');
    // owl2.owlCarousel({
    //    autoWidth: true,
    //    margin: 10,
    //    pagination: true
    // });
    // $('.prevBtn').click(function () {
    //    owl2.trigger('owl.prev');
    //    return false;
    // });
    // $('.nextBtn').click(function () {
    //    owl2.trigger('owl.next');
    //    return false;
    // });

    if ($('#itemsSlider').length > 0) {
        var owl = $('#itemsSlider');

        if ($(window).width() > 959) {
            owl.owlCarousel({
                autoWidth: true,
                margin: 10,
                pagination: false,
            });

            $('.prevBtn').click(function () {
                owl.trigger('prev.owl.carousel');
                return false;
            });

            $('.nextBtn').click(function () {
                owl.trigger('next.owl.carousel');
                return false;
            });
        } else {
            owl.attr('id', '');
        }
    }
});

function displayDetailedImage(el) {
    var src = $(el).find('img').data('low-src');
    var originalSrc = $(el).find('img').data('original-src');

    $('.image_zoom_box img').attr('src', '');
    $('.image_zoom_box').css('background', 'url(' + src + ') no-repeat center center');
    $('.image_zoom_box').css('background-size', 'cover');
    $('.image_zoom_box img').attr('src', originalSrc);

    // $('#zoom-slider').bxSlider({
    // 	mode: 'fade',
    // 	auto: false,
    // 	slideWidth: 600,
    // 	touchEnabled: false,
    // 	onSliderLoad: function () {
    // 		$('#zoom-slider li').css('visibility', 'visible');
    // 	}
    // });
}

$('#flexslider li').click(function () {
    $('body, html').css('overflow', 'hidden');
    $('.image_zoom_container').show();
    // $('.new_image_zoom_container').css('display', 'flex');

    displayDetailedImage(this);
});

// $('#flexcarousel li a').click(function (e) {
//     e.preventDefault();
//
//     var index = $(this).data('slide-index');
//     mainSlider.goToSlide(parseInt(index));
//
//     $(".flexcarousel li a").removeClass('active');
//     $(this).addClass('active');
// });

$('.image_thumbnail ul li').click(function () {
    displayDetailedImage(this);
});

$('.image_zoom_container .close').click(function () {
// $('.new_image_zoom_container .close').click(function () {
    $('.image_zoom_container').fadeOut();
    // $('.new_image_zoom_container').fadeOut();
    $('body, html').css('overflow', 'scroll');
});

$('.productImageWrapper .flexThumbnailsBox .nav').click(function () {
    if ($(this).hasClass('nav--top')) {
        $(".productImageWrapper .flexThumbnailsBox .flexCarouselBox").animate({
            scrollTop: '-=160px'
        }, 200);
    } else if ($(this).hasClass('nav--bottom')) {
        $(".productImageWrapper .flexThumbnailsBox .flexCarouselBox").animate({
            scrollTop: '+=160px'
        }, 200);
    }
});

var starRatingOption = {
    initialRating: 0,
    useGradient: false,
    activeColor: '#A47B24',
    strokeColor: '#A47B24',
    strokeWidth: 5,
    starSize: screen.width < 768 ? 12 : 18,
    readOnly: true
}

$(".noRateStar").starRating(Object.assign(starRatingOption, {
    initialRating: 0,
    starSize: screen.width < 768 ? 12 : 14
}));
$(".rateStar.one").starRating(Object.assign(starRatingOption, {initialRating: 1}));
$(".rateStar.one-half").starRating(Object.assign(starRatingOption, {initialRating: 1.5}));
$(".rateStar.two").starRating(Object.assign(starRatingOption, {initialRating: 2}));
$(".rateStar.two-half").starRating(Object.assign(starRatingOption, {initialRating: 2.5}));
$(".rateStar.three").starRating(Object.assign(starRatingOption, {initialRating: 3}));
$(".rateStar.three-half").starRating(Object.assign(starRatingOption, {initialRating: 3.5}));
$(".rateStar.four").starRating(Object.assign(starRatingOption, {initialRating: 4}));
$(".rateStar.four-half").starRating(Object.assign(starRatingOption, {initialRating: 4.5}));
$(".rateStar.five").starRating(Object.assign(starRatingOption, {initialRating: 5}));

function shareOnWhatsapp(param) {
    var url = 'https://api.whatsapp.com/send?text=' + param;

    window.open(url, '_blank');

    return false;
}

function shareOnFacebook(param) {
    var url = 'https://www.facebook.com/sharer/sharer.php?u=' + param;

    window.open(url, '_blank');

    return false;
}

function shareOnTwitter(param) {
    var url = 'https://twitter.com/intent/tweet?url=' + param;

    window.open(url, '_blank');

    return false;
}
